export default ( { req }, inject ) => {
  const domain = ( req ? req.headers.host : window.location.hostname ).toLowerCase()

  inject( 'domain', domain )
}
